export const TOUR_ADMIN_ALL_TRANSACTION_LIST_START = "TOUR_ADMIN_ALL_TRANSACTION_LIST_START";
export const TOUR_ADMIN_ALL_TRANSACTION_LIST_SUCCESS = "TOUR_ADMIN_ALL_TRANSACTION_LIST_SUCCESS";
export const TOUR_ADMIN_ALL_TRANSACTION_LIST_ERROR = "TOUR_ADMIN_ALL_TRANSACTION_LIST_ERROR";

export const TOUR_ADMIN_PENDING_TRANSACTION_LIST_START = "TOUR_ADMIN_PENDING_TRANSACTION_LIST_START";
export const TOUR_ADMIN_PENDING_TRANSACTION_LIST_SUCCESS = "TOUR_ADMIN_PENDING_TRANSACTION_LIST_SUCCESS";
export const TOUR_ADMIN_PENDING_TRANSACTION_LIST_ERROR = "TOUR_ADMIN_PENDING_TRANSACTION_LIST_ERROR";

export const TOUR_ADMIN_COMPLETED_TRANSACTION_LIST_START = "TOUR_ADMIN_COMPLETED_TRANSACTION_LIST_START";
export const TOUR_ADMIN_COMPLETED_TRANSACTION_LIST_SUCCESS = "TOUR_ADMIN_COMPLETED_TRANSACTION_LIST_SUCCESS";
export const TOUR_ADMIN_COMPLETED_TRANSACTION_LIST_ERROR = "TOUR_ADMIN_COMPLETED_TRANSACTION_LIST_ERROR";